import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import "./PopUpNotification.scss";
import { ReactComponent as Arrow } from "./../../../assets/svg/arrow.svg";
import { Link } from "react-router-dom";
import { ReactComponent as NotificationOpen } from "../../../assets/svg/notificationOpen.svg";
import { ReactComponent as NotificationReceived } from "../../../assets/svg/notificationReceived.svg";
import { ReactComponent as Close } from "../../../assets/svg/close.svg";
import { useTranslation } from "react-i18next";
import { useNotification } from "../../../hooks/useNotification";
import { useAuthValidation } from "../../../hooks/useAuthValidation";

Modal.setAppElement("#root");

function PopUpNotification({ isOpen, closeModal }) {
  const { t } = useTranslation();
  const { user, loading } = useAuthValidation();
  const { notifications, loading: loadingNotifications, markNotificationsAsRead } = useNotification();
  const [sortedNotifications, setSortedNotifications] = useState([]);

  useEffect(() => {
    if (notifications.length > 0) {
      const sorted = [...notifications].sort((a, b) => new Date(b.datatime) - new Date(a.datatime)).slice(0, 5); // Pega apenas as 5 últimas notificações
      setSortedNotifications(sorted);
    }
  }, [notifications]);

  // Função que será chamada quando o modal for fechado
  const handleCloseModal = () => {
    markNotificationsAsRead(); // Marca as notificações como lidas
    closeModal(); // Fecha o modal
  };

  if (loading || loadingNotifications) {
    return <div className="loading">{t("loading")}</div>;
  }

  if (!user) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleCloseModal} // Aqui é onde o modal será fechado, e as notificações marcadas como lidas
      contentLabel={t("notification-title-2")}
      className="open-notification"
    >
      <div className="row">
        <h2>{t("notification-title-2")}</h2>
        <button
          onClick={handleCloseModal} // Ao clicar no botão de fechar, chamamos a mesma função
          className="row link"
        >
          <Close />
        </button>
      </div>
      <ul className="column">
        {sortedNotifications.length === 0 ? (
          <li>{t("notification-none")}</li>
        ) : (
          sortedNotifications.map((notification, index) => (
            <li className="row" key={index}>
              {notification.isRead === 1 ? <NotificationOpen /> : <NotificationReceived />}
              <div>
                <p className={notification.isRead === 1 ? "read" : "unread"}>{notification.title}</p>
                <span>{notification.datatime}</span>
              </div>
            </li>
          ))
        )}
      </ul>
      <Link to="/notificacao" className="button row">
        <span>{t("notification-button")}</span>
        <Arrow />
      </Link>
    </Modal>
  );
}

export default PopUpNotification;
